import ApiHelper from "@/shared/ApiHelper";
import analytics from "@/lib/analytics";
import { Alert, Button, Label, TextInput } from "flowbite-react";
import AuthCard from "@/components/layouts/AuthCard";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { RiEarthFill } from "react-icons/ri";

export default function Recuperar() {
    const router = useRouter()
    const [email, setEmail] = useState("");
    const [spinner, setSpinner] = useState(false)
    const [enviado, setEnviado] = useState(false)
    const [mensagem, setMensagem] = useState("")

    const formSubmit = async (event: any) => {
        event.preventDefault()

        try {
            if (spinner) return

            setSpinner(true)
            const res = await ApiHelper.post({
                method: "POST",
                url: ApiHelper.recuperarSenha,
                data: { email },
                recaptcha: 'recuperar_senha'
            })

            setSpinner(false)

            if (res.response) {
                analytics.recuperarSenha()
                setEnviado(true)
                setMensagem("Enviamos as intruções para seu email, verifique também sua caixa de spam.")
            } else {
                setEnviado(false)
                setMensagem(res.dados)
            }
        } catch (e: any) {
            setSpinner(false)
            setEnviado(false)
            setMensagem(e.message)
        }
    }

    return (
        <AuthCard titulo="Recuperar senha" ajuda={true}>
            <form onSubmit={formSubmit} className="space-y-5">
                <p className="text-sm text-gray-600">
                    Informe seu e-mail para darmos continuidade.
                </p>

                {mensagem != '' && (
                    <Alert color={enviado ? 'success' : 'failure'}>
                        <span>
                            <span className="font-bold">Atenção!</span>
                            {' ' + mensagem}
                        </span>
                    </Alert>
                )}

                {enviado && (
                    <Button onClick={() => {router.push('/')}} color={'failure'} className="w-full">
                        <RiEarthFill size="18" className="mr-2"/> Home
                    </Button>
                )}

                {!enviado && (
                    <>
                        <div>
                            <div className="mb-2 block">
                                <Label htmlFor="email" value="E-mail" />
                            </div>
                            <TextInput
                                id="email"
                                type="text"
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Digite seu e-mail"
                                required={true}
                            />
                        </div>
                        <Button type="submit" color={spinner ? 'gray' : 'failure'} className="w-full">
                            {spinner ? 'AGUARDE..' : 'ENVIAR'}
                        </Button>
                        <p className="text-center text-sm">
                            <Link href="/auth/login" className="font-medium text-myred">‹ Voltar para o login</Link>
                        </p>
                    </>
                )}
            </form>
        </AuthCard>
    )
}
